<template>
  <div>
    <group>
      <cell title="油品">循环油</cell>
      <x-input title="单价">
        <template v-slot:right>元/桶</template>
      </x-input>
      <x-input title="数量"></x-input>
    </group>
    <group>
      <upload-file title="用油确认单"></upload-file>
    </group>
    <button class="button-bottom-wrap" style="display: flex;">
      <button class="button-bottom" style="background: #454545;">
        拒绝
      </button>
      <button class="button-bottom">
        确认
      </button>
    </button>
  </div>
</template>

<script>
import uploadFile from "@/components/Upload/UploaderFile";
export default {
  components: { uploadFile }
};
</script>

<style></style>
